import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { WOOSMAP_URL, WOOSMAP_GOOGLE_URL, WOOSMAP_KEY } from '~/const/3rd';
import CONFIG_STORE_LOCATOR from '~/const/3rd/woosmap/config-store-locator.json';
import { typeDefinition } from '~/helpers/editorial-helper';
import { fetchContent } from '~/services/editorial';
import Seo from '~/components/functional/Seo/EditorialSeo.vue';
import OpenGraph from '~/components/functional/OpenGraph/EditorialOpenGraph.vue';

const GlobalRichText = () => import(
/* webpackChunkName:"global-editorial" */
'~/components/atoms/Editorial/Global/GlobalRichText.vue');

const GlobalTitle = () => import(
/* webpackChunkName:"global-editorial" */
'~/components/atoms/Editorial/Global/GlobalTitle.vue');

export default {
  components: {
    GlobalTitle,
    GlobalRichText,
    Seo,
    OpenGraph
  },

  asyncData(_ref) {
    return _asyncToGenerator(function* () {
      let {
        error,
        store
      } = _ref;

      try {
        const {
          type
        } = typeDefinition('store-locator');
        const {
          results: [{
            id,
            data
          }]
        } = yield fetchContent(store, {
          type
        });
        return {
          type,
          template: {
            data
          },
          id,
          slices: []
        };
      } catch (e) {
        error({
          statusCode: 404,
          message: 'Not Found'
        });
        console.log(e);
      }

      return false;
    })();
  },

  data() {
    return {
      mapInitialized: false,
      tcVars: Object.seal({
        referer: this.$route.path,
        ga_link_state: '0',
        language: '',
        market: '',
        currentShop: '',
        currentShopId: '',
        newsletterEmail: '',
        env_3ds_activated: '0',
        page_url: this.$route.path,
        env_template: 'Home Page',
        env_work: 'Production',
        env_channel: 'site web',
        euro_rate_change: '1',
        env_language: '',
        env_country: '',
        user_id: '',
        user_email: '',
        user_category: '',
        compteur_meuble: 0,
        compteur_deco: 0
      })
    };
  },

  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    user: 'user/me'
  })),

  created() {
    this.setTcVars('init woosmap');
    this.$root.$on('reset-tcvars', () => {
      this.setTcVars('woosmap reset tcVars');
    });
  },

  mounted() {
    this.$root.$on('woosmap-loaded', this.initMap);

    if ('WebApp' in window) {
      this.initMap();
    }
  },

  destroyed() {
    this.mapInitialized = false;
  },

  methods: {
    initMap() {
      try {
        const webapp = new window.WebApp('store-locator', WOOSMAP_KEY);
        const isMobile = document.querySelector('body').clientWidth < 900;
        CONFIG_STORE_LOCATOR.internationalization.lang = this.locale.language;
        CONFIG_STORE_LOCATOR.maps.localities.language = this.locale.language;
        webapp.setConf(CONFIG_STORE_LOCATOR);
        webapp.render(isMobile);
        this.mapInitialized = true;
      } catch (err) {
        if (this.$sentry) {
          this.$sentry.captureException(err);
        }
      }
    },

    setTcVars(message) {
      this.tcVars.env_country = this.locale.market;
      this.tcVars.env_language = this.locale.language;
      this.tcVars.market = this.locale.market;
      this.tcVars.language = this.locale.language;

      if (this.user) {
        this.tcVars.user_email = this.user.email;
        this.tcVars.user_id = this.user.id;
        this.tcVars.user_category = this.$cookies.get('MDM[statut]') || this.user.type || '';
      }

      if (process.client && this.$cookies.get('debugmdm')) {
        console.log(message, _objectSpread({}, this.tcVars));
      }

      this.$root.$emit('updated-tcvars', this.tcVars);
    }

  },

  head() {
    return {
      script: [{
        src: WOOSMAP_URL,
        body: true
      }, {
        src: WOOSMAP_GOOGLE_URL,
        body: true,
        async: true,
        defer: true
      }]
    };
  }

};